module.exports = __webpack_public_path__ + "img/logo1_1.161e72cb.png";